import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const SchoolManagementType = () => {
  const navigate = useNavigate();
  const [managementTypeList, setManagementTypeList] = useState([]);

  const getAuthHeader = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  const fetchSchoolManagementTypeList = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/schoolManagementTypeList`,
        getAuthHeader()
      );

      setManagementTypeList(res.data?.data.schoolManagementTypeList || []);
    } catch (err) {
      console.error(err);

      if (err.response?.status === 401) {
        Swal.fire("Session Expired", "Please login again", "warning");
        localStorage.clear();
        localStorage.clear();
        navigate("/suda/login");
      } else {
        Swal.fire(
          "Alert",
          "Failed to load school management types",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    fetchSchoolManagementTypeList();
  }, []);

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* HEADER */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{ background: "linear-gradient(90deg, #0D47A1, #1565C1)" }}
        >
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-sitemap me-2"></i> School Management Type
            List
          </h5>
        </div>
      </Card>

      {/* TABLE */}
      <Card
        className="border-0"
        style={{
          background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
          boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
        }}
      >
        <Table bordered hover responsive striped>
          <thead>
            <tr>
              <th style={headerStyle}>SL No</th>
              <th style={headerStyle}>Management Type</th>
            </tr>
          </thead>

          <tbody>
            {managementTypeList.length > 0 ? (
              managementTypeList.map((row, index) => (
                <tr key={row.id || index}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center fw-semibold">
                    {
                      row.name}
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="text-center fw-semibold text-muted">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card>
    </div>
  );
};

const headerStyle = {
  padding: "10px",
  fontWeight: "600",
  backgroundColor: "#edf7fe",
  borderBottom: "1px solid black",
  borderTop: "1px solid black",
  textAlign: "center",
};

export default SchoolManagementType;
